module.exports = __webpack_public_path__ + "img/mlh_honor_1.ba9c5428.png";